function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "delete-black-18dp"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M0,0H18V18H0Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M9.333,16H2.667A1.693,1.693,0,0,1,1,14.286V4H11V14.286A1.693,1.693,0,0,1,9.333,16ZM12,3H0V1H3l.858-1H8.143L9,1h3V3Z",
  transform: "translate(3 1)"
}));

var SvgIconBin = function SvgIconBin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_delete_",
    "data-name": "Icon delete ",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#878787",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-bin.5553ee36.svg";
export { ForwardRef as ReactComponent };